import { createAsyncThunk } from '@reduxjs/toolkit';
import ownRespondentInviteModel from 'store/models/invite';

//GET
export const fetchInviteCompany = createAsyncThunk(
  'ownRespondentInvite/fetchInviteCompany',
  async (hash: string, { rejectWithValue }) => {
    try {
      const response: { data: { data: { company_name: string } } } =
        await ownRespondentInviteModel.getInviteCompany(hash);
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

//POST
export const fetchInviteAccept = createAsyncThunk(
  'ownRespondentInvite/fetchInviteAccept',
  async (own_respondents_link_hash: string, { rejectWithValue }) => {
    try {
      const response = await ownRespondentInviteModel.postInviteAccept(
        own_respondents_link_hash,
      );
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
